'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useWindowSize } from 'usehooks-ts';

import UiUtils from '@utils/ui';

import Logo from '@images/seedkit_logo_black.svg';

export default function Footer({ className }) {
    const { width } = useWindowSize();
    const isMobile = UiUtils.isMobile(width);
    const isDesktop = !isMobile;

    let outerClass = isDesktop ? "flex flex-col items-stretch rounded-3xl overflow-hidden print:rounded-none" : "flex flex-col items-stretch rounded-3xl overflow-hidden print:rounded-none";
    if (className) {
        outerClass = `${outerClass} ${className}`;
    }

    const footerLinkClass = "font-vg-regular text-base py-[6px] no-underline hover:underline";

    return (
        <footer className={outerClass}>
            {isDesktop && (
                <>
                    <div className="p-8 bg-black print:p-0 print:bg-white">
                        <p className="font-vg-medium text-white text-xl print:text-base border-box max-w-[1312px] mx-auto print:text-black">
                            Seedkit acknowledges the Traditional Owners of the unceded lands on which we work, learn and live, 
                            and recognises the unique place held by Aboriginal and Torres Strait Islander peoples as the original owners 
                            and custodians of the lands, skies and waterways of the Australian continent.
                        </p>
                    </div>
                    <div className="flex flex-col items-stretch gap-6 pt-20 px-8 pb-6 bg-grey04 print:pt-6 print:px-0 print:bg-white">
                        <div className="w-full flex justify-between text-black border-box max-w-[1312px] mx-auto">
                            <div className="flex flex-col gap-4 items-start max-w-[501px]">
                                <Image 
                                    src={Logo} 
                                    width={135}
                                    height={39}
                                    className="h-[39px]"
                                    alt="Seedkit logo" 
                                />
                                <p className="font-vg-book text-base text-black">
                                Seedkit is powered by the Melbourne Social Equity Institute at the University of Melbourne
                                </p>
                            </div>
                            <div className="col-start-5 flex flex-col gap-3 w-[199px] print:hidden">
                                <p className="font-vg-regular text-xl">Seedkit</p>
                                <ul className="flex flex-col gap-3">
                                    <li><Link href="/about" className={footerLinkClass}>About</Link></li>
                                    <li><Link href="/login" className={footerLinkClass}>Login</Link></li>
                                    <li><Link href="/resources" className={footerLinkClass}>Resources</Link></li>
                                    <li><Link href="/contact" className={footerLinkClass}>Contact</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="w-full h-0 border border-grey02 border-box max-w-[1312px] mx-auto"></div>
                        <div className="w-full flex items-center justify-between border-box max-w-[1312px] mx-auto">
                            <div className="flex items-center gap-6 font-vg-regular text-sm text-grey print:hidden">
                                <ul className="flex gap-6 font-vg-regular text-sm text-grey">
                                    <li><Link href="/terms" className="no-underline hover:underline">Terms of Use</Link></li>
                                    <li><Link href="/privacy" className="no-underline hover:underline">Privacy Policy</Link></li>
                                    <li><Link href="/releases" className="no-underline hover:underline">Release Notes</Link></li>
                                </ul>
                            </div>
                            <p className="font-vg-book text-black text-xs2">
                                Copyright <span className="text-lg">©</span>2024 All rights reserved.
                            </p>
                        </div>
                    </div>
                </>
            )}
            {isMobile && (
                <>
                <div className="py-8 px-6 bg-black print:p-0 print:bg-white">
                    <p className="font-vg-medium text-white text-xl print:text-base print:text-black">
                        Seedkit acknowledges the Traditional Owners of the unceded lands on which we work, learn and live, 
                        and recognises the unique place held by Aboriginal and Torres Strait Islander peoples as the original owners 
                        and custodians of the lands, skies and waterways of the Australian continent.  
                    </p>
                </div>
                <div className="flex flex-col items-stretch gap-6 py-8 px-6 print:px-0 bg-grey04 print:bg-white">
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-4 items-start">
                            <Image 
                                src={Logo} 
                                width={135}
                                height={39}
                                className="h-[39px]"
                                alt="Seedkit logo" 
                            />
                            <p className="font-vg-book text-base text-black">
                            Seedkit is powered by the Melbourne Social Equity Institute at the University of Melbourne
                            </p>
                        </div>
                        <div className="flex flex-col gap-3 print:hidden">
                            <p className="font-vg-regular text-xl">Seedkit</p>
                            <ul className="flex flex-col gap-3">
                                <li><Link href="/about" className={footerLinkClass}>About</Link></li>
                                <li><Link href="/login" className={footerLinkClass}>Login</Link></li>
                                <li><Link href="/resources" className={footerLinkClass}>Resources</Link></li>
                                <li><Link href="/contact" className={footerLinkClass}>Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="h-0 border border-grey02"></div>
                    <div className="flex flex-col gap-8">
                        <ul className="flex gap-6 font-vg-regular text-sm text-grey print:hidden">
                            <li><Link href="/terms" className="no-underline hover:underline">Terms of Use</Link></li>
                            <li><Link href="/privacy" className="no-underline hover:underline">Privacy Policy</Link></li>
                            <li><Link href="/releases" className="no-underline hover:underline">Release Notes</Link></li>
                        </ul>
                        <p className="font-vg-book text-black text-xs2">
                            Copyright <span className="text-lg">©</span>2024 All rights reserved.
                        </p>
                    </div>
                </div>
                </>
            )}
        </footer>
    );
}
